import React from 'react';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexItem } from '../flex/FlexItem.component';
import { _ReactChildren } from '../../models/common.models';
import { RoutePath } from '../app/app.constants';
import { FlexLayoutModifier } from '../flex/flex.constants';

export interface HeaderProps {
  children?: _ReactChildren;
  href?: string;
  wordMark: string | React.ReactNode;
}

const defaultProps = {
  href: `/#${RoutePath.PAGE_NOT_FOUND}`
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const iconSrc = require('@els/els-styleguide-core/images/NonSolusLogo.svg');

const Header = (props: HeaderProps) => (
  <div className="c-els-header" data-testid="ssa-app-header">
    <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS_2X, FlexLayoutModifier.MIDDLE]} classes={['c-els-header__container']}>
      <FlexItem>
        <span className="u-els-display-block">
          <FlexLayout modifiers={[FlexLayoutModifier.LEFT, FlexLayoutModifier.GUTTERS, FlexLayoutModifier.MIDDLE]}>
            <FlexItem>
              <img className="c-els-header__logo-img" src={iconSrc} alt="" data-testid="ssa-app-header-logo" />
            </FlexItem>
            <FlexItem classes={['u-els-color-primary u-els-font-size-h3 u-els-font-size-h4@mobile']}>
              <span data-testid="ssa-app-header-wordmark">{props.wordMark}</span>
            </FlexItem>
          </FlexLayout>
        </span>
      </FlexItem>
      <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
        { props.children }
      </FlexItem>
    </FlexLayout>
  </div>
);

Header.defaultProps = defaultProps;

export default Header;
